"use client";

import featureFlagService from '@services/feature-flag.service';
import { useEffect } from 'react';

/**
 * FeatureFlagInitializer component responsible for loading feature flags
 * on application initialization
 * 
 * Fetches feature flags from the backend and stores them in sessionStorage
 * for quick access throughout the application lifecycle
 */
export const FeatureFlagInitializer = ({ children }) => {
    useEffect(() => {
        const loadFeatureFlags = async () => {
            try {
                const storedFlags = sessionStorage.getItem('featureFlags');
                const featureFlags = JSON.parse(storedFlags);
                if (featureFlags?.featureFlags?.length && featureFlags.validTill > Date.now()) {
                    // Feature flags are already loaded and valid
                    return;
                }
                // Fetch feature flags from the backend service
                const flags = await featureFlagService.fetchFeatureFlags();

                // Store feature flags in sessionStorage for quick access
                sessionStorage.setItem('featureFlags', JSON.stringify({
                    // validTill: Date.now() + 3600000, // 1 hour
                    // validTill: Date.now() + + 10000, // 10 seconds for testing
                    validTill: Date.now() + 600000, // 10 minutes
                    featureFlags: flags
                }));
            } catch (error) {
                console.log('Failed to load feature flags:', error);

                // Set an empty array of feature flags in case of error
                // This ensures the application can still function
            }
        };

        // Trigger feature flag loading
        loadFeatureFlags();
    }, []); // Empty dependency array ensures this runs only once on mount

    // Render children components
    return children;
};